"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalProductListType = exports.PersonalProductListAction = exports.PersonalProductList = exports.Name = void 0;
const Name = exports.Name = 'personal-product-list';
const PersonalProductList = exports.PersonalProductList = Name;
let PersonalProductListAction = exports.PersonalProductListAction = /*#__PURE__*/function (PersonalProductListAction) {
  PersonalProductListAction["Create"] = "create";
  PersonalProductListAction["Update"] = "update";
  PersonalProductListAction["Delete"] = "delete";
  return PersonalProductListAction;
}({});
let PersonalProductListType = exports.PersonalProductListType = /*#__PURE__*/function (PersonalProductListType) {
  PersonalProductListType["Personal"] = "personal";
  PersonalProductListType["Private"] = "private";
  return PersonalProductListType;
}({});
